import { useEffect } from 'react';
import { applyTypography } from '@/utils/typography';
import settings from '@/content/settings.json';

/** Applica i font scelti in Impostazioni → Tipografia (default = font del tema, nessuna modifica). */
export function TypographySettings() {
  useEffect(() => {
    applyTypography(settings.typography);
  }, []);
  return null;
}
